var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
define(["require", "exports", "./domutils", "./StyleTools/StyleTools"], function (require, exports, domutils_1, StyleTools_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.MarkupsEditPanel = void 0;
    class MarkupsEditPanel extends Autodesk.Viewing.UI.DockingPanel {
        constructor(viewer, guiExtension, coreExtension) {
            var _a, _b, _c;
            super(viewer.container, 'MarkupsEditPanel', 'Style tools', {});
            this.destroyTools = (event) => {
                var _a;
                // @ts-ignore
                (_a = this.stylesContent) === null || _a === void 0 ? void 0 : _a.textContent = '';
                this.setVisible(false);
            };
            this.showTools = (styles) => {
                var _a, _b;
                // @ts-ignore
                (_a = this.stylesContent) === null || _a === void 0 ? void 0 : _a.textContent = '';
                this.container.style.height = 'auto';
                this.container.style.width = 'auto';
                this.container.style.resize = 'none';
                this.container.style.left = '10px';
                this.container.style.top = '50px';
                this.setVisible(true);
                // propagate style of markup to the extension
                this.coreExtension.setStyle(styles);
                for (const styleKey of Object.keys(styles)) {
                    const styleTool = this.getStyleTool(styleKey);
                    if (styleTool) {
                        const ctrl = styleTool.toolFactory(this.viewer, styleKey, styles[styleKey], (value) => {
                            const style = { [styleKey]: value };
                            this.coreExtension.setStyle(style);
                            this.onChangeHandler();
                        });
                        (_b = this.stylesContent) === null || _b === void 0 ? void 0 : _b.appendChild(this.createToolControl(ctrl));
                    }
                }
            };
            this.viewer = viewer;
            this.coreExtension = coreExtension;
            this.guiExtension = guiExtension;
            // Auto-fit to the content and don't allow resize.  Position at the coordinates given.
            this.container.style.height = 'auto';
            this.container.style.width = 'auto';
            this.container.style.resize = 'none';
            this.container.style.left = '10px';
            this.container.style.top = '50px';
            // @ts-ignore
            (_a = this === null || this === void 0 ? void 0 : this.coreExtension) === null || _a === void 0 ? void 0 : _a.addEventListener(Autodesk.Viewing.Extensions.Markups.Core.EVENT_MARKUP_SELECTED, (event) => {
                this.onChangeHandler();
                this.showTools(event.markup.style);
            });
            const that = this;
            // @ts-ignore
            (_b = this === null || this === void 0 ? void 0 : this.coreExtension) === null || _b === void 0 ? void 0 : _b.addEventListener(Autodesk.Viewing.Extensions.Markups.Core.EVENT_EDITMODE_CHANGED, (event) => {
                this.showTools(event.target.getStyle());
                // @ts-ignore
                that.coreExtension.editMode.addEventListener('EVENT_EDITMODE_CREATION_END', () => {
                    this.onChangeHandler();
                });
                // @ts-ignore
                that.coreExtension.editFrame.addEventListener('EVENT_EDITFRAME_EDITION_END', () => {
                    this.onChangeHandler();
                });
            });
            // @ts-ignore
            (_c = this === null || this === void 0 ? void 0 : this.coreExtension) === null || _c === void 0 ? void 0 : _c.addEventListener(Autodesk.Viewing.Extensions.Markups.Core.EVENT_EDITMODE_LEAVE, (event) => {
                this.onChangeHandler();
                this.destroyTools(event);
            });
        }
        onChangeHandler() {
            return __awaiter(this, void 0, void 0, function* () {
                if (this.triggerTimeout !== null) {
                    clearTimeout(this.triggerTimeout);
                }
                if (this.guiExtension.options.changeHandler && !this.guiExtension.changesDisabled()) {
                    this.triggerTimeout = setTimeout(() => {
                        this.onChangeHandlerProcess();
                    }, 500);
                }
            });
        }
        onChangeHandlerProcess() {
            return __awaiter(this, void 0, void 0, function* () {
                const markupsData = yield this.guiExtension.getData();
                this.guiExtension.options.changeHandler(markupsData.data, markupsData.viewerState, markupsData.name);
            });
        }
        getStyleTool(styleKey) {
            for (const st of StyleTools_1.StyleTools) {
                if (typeof st.match === 'string' && styleKey === st.match) {
                    return st;
                }
                if (st.match instanceof RegExp && st.match.test(styleKey)) {
                    return st;
                }
                if (typeof st.match === 'function' && st.match(styleKey)) {
                    return st;
                }
            }
            return null;
        }
        createToolControl(ctrl) {
            const group = document.createElement('div');
            domutils_1.addClass(group, 'style-group');
            const title = document.createElement('div');
            domutils_1.addClass(title, 'style-title');
            title.textContent = ctrl.getTitle();
            group.appendChild(title);
            const control = document.createElement('div');
            domutils_1.addClass(control, 'style-control');
            const tool = ctrl.getTool();
            if (tool) {
                control.appendChild(tool);
            }
            group.appendChild(control);
            return group;
        }
        initialize() {
            this.title = this.createTitleBar(this.titleLabel || this.container.id);
            this.container.appendChild(this.title);
            this.stylesContent = document.createElement('div');
            domutils_1.addClass(this.stylesContent, 'style-content');
            this.container.appendChild(this.stylesContent);
            this.initializeMoveHandlers(this.title);
        }
    }
    exports.MarkupsEditPanel = MarkupsEditPanel;
});
//# sourceMappingURL=MarkupEditPanel.js.map